import createAxios from '../axiosHttp';
export const customerService = {
  getCustomers,getClientById,newClient,updateClient
};

function getCustomers(pagination,filters) {
  const axios = createAxios();
  let urlPath = 'administration/customer';
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
  } else {
    urlPath += '?page=0&limit=500';
  }
  if (filters && filters.search) {
      urlPath += `&search=${encodeURIComponent(filters.search)}`;
  }
  if (filters && filters.sort) {
    if(filters.sort.sort){
        urlPath += `&sort=${filters.sort.sort}`;
    }
    if(filters.sort.order){
        urlPath += `&order=${filters.sort.order}`;
    }
  }
  return axios.get(urlPath);
}
function getClientById(id){
  const axios = createAxios();
  let urlPath = `administration/customer/${id}`;
  return axios.get(urlPath);
}
function newClient(body){
  const axios = createAxios();
  let urlPath = `administration/customer`;
  return axios.post(urlPath, body);
}
function updateClient(body, id){
  const axios = createAxios();
  let urlPath = `administration/customer/${id}`;
  return axios.put(urlPath, body);
}